import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Sidebar from './Sidebar';

const PageWithMenu = styled.div`
  display: flex;
`;

const PageContent = styled.div`
  margin-left: 250px;
  width: calc(100% - 250px);
  min-height: 100vh;
  @media (max-width: 700px) {
    margin-left: 60px;
    width: calc(100% - 60px);
  }
`;

export default class MenuPage extends Component {
  render() {
    const { role_code, path } = this.props;

    return (
      <PageWithMenu>
        <Sidebar path={path} roleCode={role_code} />
        <PageContent>{this.props.children}</PageContent>
      </PageWithMenu>
    );
  }
}

MenuPage.propTypes = {
  children: PropTypes.node,
  path: PropTypes.string,
  role_code: PropTypes.string,
};
